/**
 * Silent URL rewrite for consumed params. The router patches `window.history.replaceState` to
 * dispatch a `replaceState` event, and `BaseRouter` treats that as a navigation — loader refetch plus
 * a `screenKey` change that remounts the screen. Dropping params we already read is not a
 * navigation, so go through the unpatched prototype method (the patch installs an own property on
 * `window.history`, the prototype stays clean).
 */
export const stripQueryParams = (params: string[]) => {
    const url = new URL(window.location.href)
    const present = params.filter(param => url.searchParams.has(param))

    if (!present.length) {
        return
    }

    present.forEach(param => url.searchParams.delete(param))
    History.prototype.replaceState.call(window.history, window.history.state, '', url.toString())
}
